export const setWebAutomation = (locationKey) => ({
  type: "testAutomation/webAutomation/set",
  payload: { locationKey },
});

export const updateWebAutomation = (locationKey, key, value) => ({
  type: "testAutomation/webAutomation/update",
  payload: { locationKey, key, value },
});
